import type { Space } from '@mail/cross-sizes-utils';
import { Spacing, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type VFC } from 'react';
import { BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';

import styles from './CommonInfo.css';
import { getNumberOfShot, getStatus } from './CommonInfo.helpers';

type Props = {
    space: Space;
    isBase?: boolean;
    // tempexp_18086-next-line
    isReferral?: boolean;
    isGrace?: boolean;
    withPlus?: boolean;
    status?: BillingDataSubscriptionInfoStatus;
    customTitle?: string;
    isRebrandingQuotaLanding?: boolean;
};

function getStatusByFlags({
    isGrace,
    isReferral,
    status,
}: {
    isReferral?: boolean;
    isGrace?: boolean;
    status?: BillingDataSubscriptionInfoStatus;
}) {
    if (isReferral) {
        return 'Бонус активен';
    }
    if (isGrace) {
        return 'Подписка активна';
    }
    return getStatus(status);
}

export const CommonInfo: VFC<Props> = ({
    space,
    status,
    isBase,
    // tempexp_18086-next-line
    isReferral,
    withPlus = isReferral,
    customTitle,
    isRebrandingQuotaLanding,
    isGrace,
}) => {
    const numberOfShot = getNumberOfShot(space.original);
    const spaceString = withPlus ? `+${space.space}` : space.space;
    return (
        <div className={classNames(styles.root, { [styles.root_rebrandingQuotaLanding]: isRebrandingQuotaLanding })}>
            {customTitle ? (
                <>
                    <Spacing size={8} />
                    <Text className={styles.customTitle}>{customTitle}</Text>
                    <Spacing size={12} />
                </>
            ) : (
                <div className={styles.availableSpace}>
                    <span className={styles.space}>{spaceString}</span>
                    <span className={styles.units}>{space.units}</span>
                </div>
            )}
            {/* tempexp_18086-next-line  !isReferral*/}
            {!isReferral && !isGrace && <span className={styles.numberOfShot}>{numberOfShot}</span>}
            <span
                className={classNames(styles.status, {
                    [styles.status_active]:
                        isBase ||
                        // tempexp_18086-next-line
                        isReferral ||
                        status === BillingDataSubscriptionInfoStatus.ACTIVE ||
                        isGrace,
                    [styles.status_warning]:
                        status &&
                        [BillingDataSubscriptionInfoStatus.SUSPENDED, BillingDataSubscriptionInfoStatus.FINISHED].includes(status),
                })}
            >
                {/* tempexp_18086-next-line  isReferral и 'Бонус активен'*/}
                {getStatusByFlags({ isGrace, isReferral, status })}
            </span>
        </div>
    );
};
